module.exports = __webpack_public_path__ + "img/portraits_07_V.046cf3c7.webp";